export const environment = {
  production: true,
  apiBaseUrl: 'https://aiq-portal-tias.com.mx:9990',
  multipagosURL: '',
  mp_urlsuccess: '',
  mp_urlfailure: '',
  mp_acount: 327,
  key: 'McuOlrtriepgadgEoqsRBoa2nxc0o1m1eDr543EFteuweh',
  gKey:'AIzaSyDnD1KfsnmR-s5cysMgYNfVwUcyurCs8lo',
  dbLocalName: 'localDB',
  dbLocalVersion: 1
};

